import {ModalComponents} from 'constants/Modals';
import {Routes} from 'constants/routes';

import {useEffect} from 'react';

import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import {useGlobalState} from 'hooks/useGlobalState';
import useOnClickOutside from 'hooks/useOnClickOutside';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {NavLink} from 'react-router-dom';
import {setModalAC} from 'store/modal/modalSlice';
import {isAdmin, isManager} from 'utils/helpers/getUserRoles';

import AdminLinks from './AdminLinks/AdminLinks';
import ManagerLinks from './ManagerLinks/ManagerLinks';

import './Sidebar.scss';

interface IProps {
  showSidebar: boolean;
  setShowSidebar: React.Dispatch<React.SetStateAction<boolean>>;
}

const Sidebar = ({showSidebar = false, setShowSidebar}: IProps) => {
  const dispatch = useSetGlobalState();

  const {containerRef} = useOnClickOutside<HTMLDivElement>(() => {
    setShowSidebar(false);
    document.body.style.overflow = '';
  });

  const {user} = useGlobalState((state) => state.app);

  const handleLogout = () => dispatch(setModalAC(ModalComponents.LOGOUT_CONFIRMATION));

  useEffect(() => {
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div className={`sidebar ${showSidebar ? 'sidebar--show' : ''}`} ref={containerRef}>
      <div className="sidebar__wrapper">
        <div className="sidebar__profile">
          <NavLink
            to={Routes.PROFILE}
            className={({isActive}) =>
              isActive ? 'sidebar__profile-link sidebar__profile-link--active' : 'sidebar__profile-link'
            }
          >
            <Icon icon="user-5" />
            <Icon icon="user-5-active" /> My Profile
          </NavLink>
        </div>
        <div className="sidebar__links">
          {isManager(user!) && <ManagerLinks />}
          {isAdmin(user!) && <AdminLinks />}
        </div>
        <div className="sidebar__logout">
          <Button variant="empty" onClick={() => handleLogout()}>
            <Icon icon="logout" /> Log Out
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
